

export const Spinner = () => {
    return (
        <span className="animate-spin spinner">
        </span>
    )
}